import { render } from "./TombamentoPlanilhaView.vue?vue&type=template&id=f65ef73e&scoped=true"
import script from "./TombamentoPlanilhaView.vue?vue&type=script&lang=js"
export * from "./TombamentoPlanilhaView.vue?vue&type=script&lang=js"

import "./TombamentoPlanilhaView.vue?vue&type=style&index=0&id=f65ef73e&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65ef73e"]])

export default __exports__